import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useRecoilState } from 'recoil';

import CommunityCloseNotice from '@/components/common/CommunityCloseNotice';
import useModal from '@/hooks/useModal';
import { closedCommunityPopupDayState } from '@/recoil/atoms/common/popup';
import { Client } from '@/types/app';
import { MODAL_TYPE } from '@/types/modal';
import { isSameDate } from '@/utils/date';

const useCommunityPopup = (client: Client) => {
  const { showModal, closeModal } = useModal();
  const [closedCommunityPopupDay, setClosedCommunityPopupDay] = useRecoilState(
    closedCommunityPopupDayState,
  );
  const isClosedTodayCommunityPopup = useMemo(() => {
    if (!closedCommunityPopupDay) return false;
    return isSameDate(closedCommunityPopupDay, 'date');
  }, [closedCommunityPopupDay]);

  const onClosePopupToday = (todayInvisible: boolean) => {
    if (todayInvisible) {
      const today = dayjs().format();
      setClosedCommunityPopupDay(today);
    }
    closeModal();
  };

  const onOpenCommunityCloseNotice = () => {
    if (isClosedTodayCommunityPopup) {
      return;
    }
    showModal({
      type: MODAL_TYPE.BASIC,
      props: {
        body: (
          <CommunityCloseNotice
            client={client}
            onCloseWithTodayInvisible={onClosePopupToday}
          />
        ),
      },
    });
  };

  return {
    onOpenCommunityCloseNotice,
  };
};

export default useCommunityPopup;
